export function clampProgress(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(1, Math.max(0, value));
}

export function remapProgress(value: number, start: number, end: number): number {
  const safeStart = clampProgress(start);
  const safeEnd = clampProgress(end);

  if (safeEnd <= safeStart) return 0;

  return clampProgress((clampProgress(value) - safeStart) / (safeEnd - safeStart));
}
